import Vue from 'vue'
import Router from 'vue-router'
import { normalizeURL, decode } from 'ufo'
import { interopDefault } from './utils'
import scrollBehavior from './router.scrollBehavior.js'

const _71de061e = () => interopDefault(import('../pages/account.vue' /* webpackChunkName: "pages/account" */))
const _32954080 = () => interopDefault(import('../pages/admin.vue' /* webpackChunkName: "pages/admin" */))
const _4ea7f69c = () => interopDefault(import('../pages/contacts.vue' /* webpackChunkName: "pages/contacts" */))
const _88f36e76 = () => interopDefault(import('../pages/dashboard.vue' /* webpackChunkName: "pages/dashboard" */))
const _08bbe81e = () => interopDefault(import('../pages/directory.vue' /* webpackChunkName: "pages/directory" */))
const _785c44c4 = () => interopDefault(import('../pages/import.vue' /* webpackChunkName: "pages/import" */))
const _54212e14 = () => interopDefault(import('../pages/linkcards_no.vue' /* webpackChunkName: "pages/linkcards_no" */))
const _6a64e0cc = () => interopDefault(import('../pages/login.vue' /* webpackChunkName: "pages/login" */))
const _3739affc = () => interopDefault(import('../pages/login_old.vue' /* webpackChunkName: "pages/login_old" */))
const _481527ae = () => interopDefault(import('../pages/logout.vue' /* webpackChunkName: "pages/logout" */))
const _76e63499 = () => interopDefault(import('../pages/notifications.vue' /* webpackChunkName: "pages/notifications" */))
const _46ed44e9 = () => interopDefault(import('../pages/signature.vue' /* webpackChunkName: "pages/signature" */))
const _cb320d4c = () => interopDefault(import('../pages/signatures.vue' /* webpackChunkName: "pages/signatures" */))
const _52848d4b = () => interopDefault(import('../pages/solutions.vue' /* webpackChunkName: "pages/solutions" */))
const _65dbe373 = () => interopDefault(import('../pages/uikit.vue' /* webpackChunkName: "pages/uikit" */))
const _468fc6b9 = () => interopDefault(import('../pages/users.vue' /* webpackChunkName: "pages/users" */))
const _32280ae6 = () => interopDefault(import('../pages/wizard/index.vue' /* webpackChunkName: "pages/wizard/index" */))
const _68a8db5a = () => interopDefault(import('../pages/leads/landings.vue' /* webpackChunkName: "pages/leads/landings" */))
const _05439522 = () => interopDefault(import('../pages/leads/linkcards.vue' /* webpackChunkName: "pages/leads/linkcards" */))
const _da2f725e = () => interopDefault(import('../pages/leads/settings_landings.vue' /* webpackChunkName: "pages/leads/settings_landings" */))
const _259d7064 = () => interopDefault(import('../pages/leads/settings_linkcards.vue' /* webpackChunkName: "pages/leads/settings_linkcards" */))
const _5a753716 = () => interopDefault(import('../pages/loyalty/loyaltys.vue' /* webpackChunkName: "pages/loyalty/loyaltys" */))
const _45080e05 = () => interopDefault(import('../pages/loyalty/memberships.vue' /* webpackChunkName: "pages/loyalty/memberships" */))
const _9adfe24e = () => interopDefault(import('../pages/loyalty/mymemberships.vue' /* webpackChunkName: "pages/loyalty/mymemberships" */))
const _4e0a71c2 = () => interopDefault(import('../pages/onboarding/landing.vue' /* webpackChunkName: "pages/onboarding/landing" */))
const _1eede56f = () => interopDefault(import('../pages/onboarding/linkcard.vue' /* webpackChunkName: "pages/onboarding/linkcard" */))
const _7b494c71 = () => interopDefault(import('../pages/onboarding/loyalty.vue' /* webpackChunkName: "pages/onboarding/loyalty" */))
const _595329c2 = () => interopDefault(import('../pages/sector/import.vue' /* webpackChunkName: "pages/sector/import" */))
const _42965f2a = () => interopDefault(import('../pages/stats/linkcards.vue' /* webpackChunkName: "pages/stats/linkcards" */))
const _739d9220 = () => interopDefault(import('../pages/wizard/data.js' /* webpackChunkName: "pages/wizard/data" */))
const _a5cb8890 = () => interopDefault(import('../pages/sector/sectors/landings.vue' /* webpackChunkName: "pages/sector/sectors/landings" */))
const _51aa185d = () => interopDefault(import('../pages/sector/sectors/linkcards.vue' /* webpackChunkName: "pages/sector/sectors/linkcards" */))
const _24f8fd3a = () => interopDefault(import('../pages/wizard/steps/sector.vue' /* webpackChunkName: "pages/wizard/steps/sector" */))
const _5fb740cc = () => interopDefault(import('../pages/wizard/steps/templates.vue' /* webpackChunkName: "pages/wizard/steps/templates" */))
const _02740477 = () => interopDefault(import('../pages/wizard/steps/type.vue' /* webpackChunkName: "pages/wizard/steps/type" */))
const _18cede22 = () => interopDefault(import('../pages/wizard/steps/upgrade.vue' /* webpackChunkName: "pages/wizard/steps/upgrade" */))
const _0125ec83 = () => interopDefault(import('../pages/index.vue' /* webpackChunkName: "pages/index" */))
const _ab9ea8e0 = () => interopDefault(import('../pages/sector/sectors/_type/index.vue' /* webpackChunkName: "pages/sector/sectors/_type/index" */))
const _1fc9eac1 = () => interopDefault(import('../pages/stats/landings/_sector.vue' /* webpackChunkName: "pages/stats/landings/_sector" */))
const _34b01443 = () => interopDefault(import('../pages/sector/sectors/_type/_sector.vue' /* webpackChunkName: "pages/sector/sectors/_type/_sector" */))
const _bd08910c = () => interopDefault(import('../pages/editor/_id/index.vue' /* webpackChunkName: "pages/editor/_id/index" */))
const _141d5c3e = () => interopDefault(import('../pages/leads/_sector.vue' /* webpackChunkName: "pages/leads/_sector" */))
const _0e25665c = () => interopDefault(import('../pages/loyalty/_loyalty/index.vue' /* webpackChunkName: "pages/loyalty/_loyalty/index" */))
const _adb333ea = () => interopDefault(import('../pages/sectors/_type/index.vue' /* webpackChunkName: "pages/sectors/_type/index" */))
const _5cec99b4 = () => interopDefault(import('../pages/templates/_type.vue' /* webpackChunkName: "pages/templates/_type" */))
const _7980ee55 = () => interopDefault(import('../pages/loyalty/_loyalty/import.vue' /* webpackChunkName: "pages/loyalty/_loyalty/import" */))
const _958f10ce = () => interopDefault(import('../pages/loyalty/_loyalty/members.vue' /* webpackChunkName: "pages/loyalty/_loyalty/members" */))
const _a4ff8bc2 = () => interopDefault(import('../pages/loyalty/_loyalty/stats.vue' /* webpackChunkName: "pages/loyalty/_loyalty/stats" */))
const _7a0c2800 = () => interopDefault(import('../pages/sector/_sector/landings.vue' /* webpackChunkName: "pages/sector/_sector/landings" */))
const _22f5b515 = () => interopDefault(import('../pages/sector/_sector/linkcards.vue' /* webpackChunkName: "pages/sector/_sector/linkcards" */))
const _6eca0a4a = () => interopDefault(import('../pages/linkcards/_uid/_sid/index.vue' /* webpackChunkName: "pages/linkcards/_uid/_sid/index" */))
const _112a4bd6 = () => interopDefault(import('../pages/sharing/_user/_id/index.vue' /* webpackChunkName: "pages/sharing/_user/_id/index" */))

const emptyFn = () => {}

Vue.use(Router)

export const routerOptions = {
  mode: 'history',
  base: '/',
  linkActiveClass: 'nuxt-link-active',
  linkExactActiveClass: 'nuxt-link-exact-active',
  scrollBehavior,

  routes: [{
    path: "/account",
    component: _71de061e,
    name: "account"
  }, {
    path: "/admin",
    component: _32954080,
    name: "admin"
  }, {
    path: "/contacts",
    component: _4ea7f69c,
    name: "contacts"
  }, {
    path: "/dashboard",
    component: _88f36e76,
    name: "dashboard"
  }, {
    path: "/directory",
    component: _08bbe81e,
    name: "directory"
  }, {
    path: "/import",
    component: _785c44c4,
    name: "import"
  }, {
    path: "/linkcards_no",
    component: _54212e14,
    name: "linkcards_no"
  }, {
    path: "/login",
    component: _6a64e0cc,
    name: "login"
  }, {
    path: "/login_old",
    component: _3739affc,
    name: "login_old"
  }, {
    path: "/logout",
    component: _481527ae,
    name: "logout"
  }, {
    path: "/notifications",
    component: _76e63499,
    name: "notifications"
  }, {
    path: "/signature",
    component: _46ed44e9,
    name: "signature"
  }, {
    path: "/signatures",
    component: _cb320d4c,
    name: "signatures"
  }, {
    path: "/solutions",
    component: _52848d4b,
    name: "solutions"
  }, {
    path: "/uikit",
    component: _65dbe373,
    name: "uikit"
  }, {
    path: "/users",
    component: _468fc6b9,
    name: "users"
  }, {
    path: "/wizard",
    component: _32280ae6,
    name: "wizard"
  }, {
    path: "/leads/landings",
    component: _68a8db5a,
    name: "leads-landings"
  }, {
    path: "/leads/linkcards",
    component: _05439522,
    name: "leads-linkcards"
  }, {
    path: "/leads/settings_landings",
    component: _da2f725e,
    name: "leads-settings_landings"
  }, {
    path: "/leads/settings_linkcards",
    component: _259d7064,
    name: "leads-settings_linkcards"
  }, {
    path: "/loyalty/loyaltys",
    component: _5a753716,
    name: "loyalty-loyaltys"
  }, {
    path: "/loyalty/memberships",
    component: _45080e05,
    name: "loyalty-memberships"
  }, {
    path: "/loyalty/mymemberships",
    component: _9adfe24e,
    name: "loyalty-mymemberships"
  }, {
    path: "/onboarding/landing",
    component: _4e0a71c2,
    name: "onboarding-landing"
  }, {
    path: "/onboarding/linkcard",
    component: _1eede56f,
    name: "onboarding-linkcard"
  }, {
    path: "/onboarding/loyalty",
    component: _7b494c71,
    name: "onboarding-loyalty"
  }, {
    path: "/sector/import",
    component: _595329c2,
    name: "sector-import"
  }, {
    path: "/stats/linkcards",
    component: _42965f2a,
    name: "stats-linkcards"
  }, {
    path: "/wizard/data",
    component: _739d9220,
    name: "wizard-data"
  }, {
    path: "/sector/sectors/landings",
    component: _a5cb8890,
    name: "sector-sectors-landings"
  }, {
    path: "/sector/sectors/linkcards",
    component: _51aa185d,
    name: "sector-sectors-linkcards"
  }, {
    path: "/wizard/steps/sector",
    component: _24f8fd3a,
    name: "wizard-steps-sector"
  }, {
    path: "/wizard/steps/templates",
    component: _5fb740cc,
    name: "wizard-steps-templates"
  }, {
    path: "/wizard/steps/type",
    component: _02740477,
    name: "wizard-steps-type"
  }, {
    path: "/wizard/steps/upgrade",
    component: _18cede22,
    name: "wizard-steps-upgrade"
  }, {
    path: "/",
    component: _0125ec83,
    name: "index"
  }, {
    path: "/sector/sectors/:type",
    component: _ab9ea8e0,
    name: "sector-sectors-type"
  }, {
    path: "/stats/landings/:sector?",
    component: _1fc9eac1,
    name: "stats-landings-sector"
  }, {
    path: "/sector/sectors/:type?/:sector",
    component: _34b01443,
    name: "sector-sectors-type-sector"
  }, {
    path: "/editor/:id",
    component: _bd08910c,
    name: "editor-id"
  }, {
    path: "/leads/:sector?",
    component: _141d5c3e,
    name: "leads-sector"
  }, {
    path: "/loyalty/:loyalty",
    component: _0e25665c,
    name: "loyalty-loyalty"
  }, {
    path: "/sectors/:type",
    component: _adb333ea,
    name: "sectors-type"
  }, {
    path: "/templates/:type?",
    component: _5cec99b4,
    name: "templates-type"
  }, {
    path: "/loyalty/:loyalty?/import",
    component: _7980ee55,
    name: "loyalty-loyalty-import"
  }, {
    path: "/loyalty/:loyalty?/members",
    component: _958f10ce,
    name: "loyalty-loyalty-members"
  }, {
    path: "/loyalty/:loyalty?/stats",
    component: _a4ff8bc2,
    name: "loyalty-loyalty-stats"
  }, {
    path: "/sector/:sector?/landings",
    component: _7a0c2800,
    name: "sector-sector-landings"
  }, {
    path: "/sector/:sector?/linkcards",
    component: _22f5b515,
    name: "sector-sector-linkcards"
  }, {
    path: "/linkcards/:uid?/:sid",
    component: _6eca0a4a,
    name: "linkcards-uid-sid"
  }, {
    path: "/sharing/:user?/:id",
    component: _112a4bd6,
    name: "sharing-user-id"
  }],

  fallback: false
}

export function createRouter (ssrContext, config) {
  const base = (config._app && config._app.basePath) || routerOptions.base
  const router = new Router({ ...routerOptions, base  })

  // TODO: remove in Nuxt 3
  const originalPush = router.push
  router.push = function push (location, onComplete = emptyFn, onAbort) {
    return originalPush.call(this, location, onComplete, onAbort)
  }

  const resolve = router.resolve.bind(router)
  router.resolve = (to, current, append) => {
    if (typeof to === 'string') {
      to = normalizeURL(to)
    }
    return resolve(to, current, append)
  }

  return router
}
